import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import Common from '../Common/common';
import moment from 'moment';
import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';

const TrainTotalCancel = (props) => {
    const { addToast } = useToasts();
    const { settings } = props;
    const [cancelfee, setcancelfee] = useState('0');
    const { bookDate, ticketId } = useParams();
    const [bookData, setBookData] = useState([]);
    const [stopReason, setStopReason] = useState("");
    const [ticketdata, setTicketData] = useState([]);

    const refreshMaster = useCallback(async () => {
        //トークンを取得
        const jwt = localStorage.getItem('jwt');

        var reg_params = {};
        reg_params = {
            "operator": "and",
            "where": [
                { "site_id": props.siteId }
            ]
        }
        var param = {
            "operator": "and",
            "where": [
                { "site_id": props.siteId },
                { "book_date": moment(bookDate).format("YYYY/MM/DD") },
            ]
        }

        const data = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/train_booking/search/`, param, { headers: { Authorization: `Bearer ${jwt}` } })).data;
        const ticketdata = (await axios.post(`${process.env.REACT_APP_BACKEND_URL}/ticket/search/`, reg_params, { headers: { Authorization: `Bearer ${jwt}` } })).data;
        setTicketData(ticketdata);
        setBookData(data);
    }, [props.siteId, bookDate]);

    const handleChangeStopReason = (e) => {
        const target = e.target;
        setStopReason(target.value);
    }
    const handleStatusButtonClick = async (data, status) => {

        const max = ticketdata.map(a => a.amount);
        if (Number(cancelfee) > max) {
            alert(`キャンセル料は最大値（${max}円）を超えることはできません。`);
            return;
        }
        if(stopReason === ""){
            alert(`キャンセル理由を選択してください`);
            return;
        }

        var message = "";

        message = `予約を一括キャンセルします。よろしいですか？`;

        if (!window.confirm(message)) {
            return;
        }
        const param = {
            site_id: props.match.params.siteId,
            ticket_id: ticketId,
            book_date: bookDate,
            cancel_reason: stopReason,
            upd_name: props.user.userId,
        }

        try {
            const jwt = localStorage.getItem('jwt');

            const filteredData = bookData.filter(p =>
                (p.status === "REG" || p.status === "FIN" || p.status === "OVER") &&
                moment(p.book_date).format("YYYYMMDD") === bookDate &&
                Number(p.ticket_id) === Number(ticketId)
            );

            const UPAYData = bookData.filter(p =>
                (p.status === "UPAY") &&
                moment(p.book_date).format("YYYYMMDD") === bookDate &&
                Number(p.ticket_id) === Number(ticketId)
            );

            const reg_params = {
                site_id: filteredData.map(a => a.site_id),
                book_id: filteredData.map(a => a.book_id),
                refund_total: filteredData.map(a => (Number(ticketdata.find(item => item.ticket_id === Number(ticketId)).amount) * Number(a.count)) - cancelfee),
                upd_name: props.user.userId,
            };

            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/calendar/stop`, param, { headers: { Authorization: `Bearer ${jwt}` } });

            for (let i = 0; i < filteredData.length; i++) {
                const param = {
                    site_id: reg_params.site_id[i],
                    book_id: reg_params.book_id[i],
                    book_date: moment(bookDate).format("YYYY-MM-DD"),
                    ticket_id: ticketId,
                    refund_total: reg_params.refund_total[i],
                    upd_name: props.user.userId,
                };
                console.log(param);
                
                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/bulkcancel/`, param, { headers: { Authorization: `Bearer ${jwt}` } });
            }

            for (let i = 0; i < UPAYData.length; i++) {
                const item = UPAYData[i];
                const params = {
                    site_id: item.site_id,
                    book_id: item.book_id,
                    book_date: moment(bookDate).format("YYYY-MM-DD"),
                    ticket_id: ticketId,
                    upd_name: item.upd_name,
                };
                await axios.post(`${process.env.REACT_APP_BACKEND_URL}/booking/upaycancel/`, params, { headers: { Authorization: `Bearer ${jwt}` } });
            }
            addToast('ステータスを更新しました。', { appearance: 'success', autoDismiss: true });
        } catch (err) {
            if (err.response.data !== null) {
                addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
            } else {
                addToast(err.response, { appearance: 'error', autoDismiss: true });
            }
        } finally {
            await refreshMaster();
        }
    }
    const renderCancelButton = (data) => {
        const datalist = bookData.filter(x => x.book_id === data.book_id);
        const chk = datalist.reduce((chk, item) => (chk && constClass.STATUS_PRE.includes(item.status)), true);
        const status = (chk) ? constClass.STATUS.CCL : constClass.STATUS.CFIN;
        const additionalStatus = [constClass.STATUS.CCL, constClass.STATUS.CFIN];
        return (<button type="button"
            className={`btn ${additionalStatus.includes(data.status) ? 'btn-danger' : (constClass.ACTIVE_BUTTONS[data.status] && constClass.ACTIVE_BUTTONS[data.status].includes(status) ? 'btn-danger' : 'btn-danger')} mx-1`
            }
            onClick={() => handleStatusButtonClick(data)}>
            一括キャンセル
        </button >
        )
    }

    const stopReasonItem = () => {
        const items = [];
        var list = JSON.parse(Common.getSettingValue(settings, "STOP_REASON_LIST", []));
        items.push(<option value="" key={"-"}>- 停止理由を選択してください。 -</option>)
        list.forEach((data, idx) => {
            items.push(<option value={data} key={idx}>{data}</option>)
        });
        return items;
    }
    const handleChange = (event) => {
        const value = event.target.value;

        // 数字でない場合のチェック
        if (value !== "" && !/^[0-9]+$/.test(value)) {
            alert('エラー: 正の整数で入力してください');
            setcancelfee(0);
        } else {
            // 0または空欄以外は先頭の0を除去
            if (value === "0" || value === "") {
                setcancelfee(value);
            } else {
                setcancelfee(value.replace(/^0+/, ""));
            }
        }
    };

    useEffect(() => {
        refreshMaster();
    }, [refreshMaster]);

    const renderList = () => {

        return (
            <div className="row pt-1 pb-2">
                <div className="col-11">
                    <div className="row pt-4 pb-3">
                        <div className="col-3 text-center align-self-center">
                            <span className="h3">{`${bookDate.slice(0, 4)}/${bookDate.slice(4, 6)}/${bookDate.slice(6, 8)}`}</span>
                        </div>
                        <div className="col-4 text-center align-self-center">{ticketdata &&
                            <span className="h3">{ticketdata.find(x => Number(x.ticket_id) === Number(ticketId)) ? ticketdata.find(x => Number(x.ticket_id) === Number(ticketId)).ticket_name : ''}</span>}
                        </div>
                    </div>
                    <div className="col text-center mb-4">
                        {/* <div className="row pt-4 pb-3">
                            <div className="col-2 text-center align-self-center">
                                <span>キャンセルしたユーザ</span>
                            </div>
                            <div className="col-4 text-center align-self-center">
                                
                            </div>
                        </div> */}
                        <div className="row pt-4 pb-3">
                            <div className="col-2 text-center align-self-center">
                                <span>キャンセル理由</span>
                            </div>
                            <div className="col-4 text-center align-self-center">
                                <select className="custom-select w-100" aria-label="停止理由" id="stop_reason" name="stop_reason" value={stopReason} onChange={handleChangeStopReason}>
                                    {stopReasonItem()}
                                </select>
                            </div>
                        </div>
                        <div className="row pt-4">
                            <div className="col-2 text-center align-self-center">
                                <span>キャンセル料</span>
                            </div>
                            <div className="col-2 text-center pb-3">
                                <input type="number" className="form-control" value={cancelfee} onChange={handleChange}></input>
                            </div>
                            <div className="col-1 text-center align-self-center"><span>円</span></div>
                        </div>
                        {renderCancelButton(bookData.filter(x => x.status !== 'CCL' && x.status !== 'UPAY' && x.status !== 'CUPAY' && moment(x.book_date).format('YYYYMMDD') === moment(bookDate).format('YYYYMMDD') && Number(x.ticket_id) === Number(ticketId)))}
                    </div>
                </div>
                <div className="mb-3"></div>
                <div className="col-11">
                    <table className="table table-bordered text-center" height="1">
                        <thead>
                            <tr>
                                <th className='align-middle'>ステータス</th>
                                <th className='align-middle'>予約件数</th>
                                <th className='align-middle'>予約人数</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[...new Set(bookData
                                .filter(x => x.status !== 'CCL' && x.status !== 'UPAY' && x.status !== 'CUPAY' && moment(x.book_date).format('YYYYMMDD') === moment(bookDate).format('YYYYMMDD') && Number(x.ticket_id) === Number(ticketId))
                                .map(item => item.status))].map(status => {
                                    const filteredData = bookData.filter(b => b.status === status && moment(b.book_date).format('YYYYMMDD') === moment(bookDate).format('YYYYMMDD') && Number(b.ticket_id) === Number(ticketId));
                                    return (
                                        <tr key={status}>
                                            <td className='align-middle'>{constClass.STATUS_NAME[status]}</td>
                                            <td className='align-middle'>{filteredData.length}</td>
                                            <td className='align-middle'>{filteredData.reduce((x, item) => x + item.count, 0)}</td>
                                        </tr>
                                    );
                                })}
                            <tr>
                                <th className='align-middle'>合計</th>
                                <td className='align-middle'>{bookData.filter(item => item.status !== 'CCL' && item.status !== 'UPAY' && item.status !== 'CUPAY' && moment(item.book_date).format('YYYYMMDD') === moment(bookDate).format('YYYYMMDD') && Number(item.ticket_id) === Number(ticketId)).length}</td>
                                <td className='align-middle'>
                                    {bookData
                                        .filter(item => item.status !== 'CCL' && item.status !== 'UPAY' && item.status !== 'CUPAY' && moment(item.book_date).format('YYYYMMDD') === moment(bookDate).format('YYYYMMDD') && Number(item.ticket_id) === Number(ticketId))
                                        .reduce((acc, item) => acc + item.count, 0)}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="row d-none"><div className="col-12">{util.inspect(bookData)}</div></div>
            <div className="row d-none"><div className="col-12">{util.inspect(props.user)}</div></div>
            {ticketdata === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
            {ticketdata !== null && renderList()}
        </div>
    );
}

export default TrainTotalCancel;